/**
 * 微信授权
 * https://developers.weixin.qq.com/miniprogram/dev/framework/open-ability/authorize.html
 */
import { TRACK_ENTRY_TYPE } from '@/config';
import authUtils from '../authUtils';

const { officialAccountsId: configOffId } = authUtils.config;
const wechatApi = authUtils.wechatApi;
const readerCenterApi = authUtils.readerCenterApi;
const channelCenterApi = authUtils.channelCenterApi;

class WxAuthorize {
  constructor({
    query,
    snsapiBase,
    officialAccountsId,
    phone,
    noRequired,
    defaultAuthorize
  }) {
    this.query = query || {};

    this.snapsis = snsapiBase || false; // true ：静默 、false: 非静默
    this.officialAccountsId = officialAccountsId || configOffId;
    this.phone = phone || ''; // 手机登录后，静默授权关联用户id
    this.noRequired = noRequired || false; // 无需授权查看
    this.defaultAuthorize = defaultAuthorize || false; // 是否需要进入时授权
  }

  /**
   * 检查是否存在openid
   * @returns {boolean}
   */
  checkOpenid() {
    return !!this.query.openid;
  }

  /**
   * 通过openid获取用户信息
   */
  getByOpenid() {
    const data = {
      openId: this.query.openid,
      officialAccountsId: this.officialAccountsId
    };
    return readerCenterApi.getUserInfoByOpenId(data);
  }

  /**
   * 检查微信ID是否合法
   */
  checkLogged() {
    const { wechatUserId, userType } = authUtils.getCookieUser();
    // 不用授权
    if(this.noRequired) {
      return true;
    }
    // 是否真实用户
    return userType === authUtils.CONSTANT.USER_TYPE_REGULAR && !!wechatUserId;
  }

  /**
   * 进入默认授权
   */
  enterAuthorize() {
    return this.defaultAuthorize;
  }

  /**
   * 是否有code信息
   * @returns {boolean}
   */
  checkCode() {
    return !!this.query.code;
  }

  /**
   * 通过code获取用户信息
   * @returns Promise
   */
  getByCode() {
    const { code, phone } = this.query;
    const data = {
      code,
      phone,
      officialAccountsId: this.officialAccountsId,
      trackEntryType: TRACK_ENTRY_TYPE
    };
    return wechatApi.authorizeUser(data);
  }

  /**
   * 发起授权
   */
  forward= async () => {
    // 存在不是微信，默认为微信授权方式
    if(!authUtils.browser().wechat) return;
    //重定向到微信授权界面
    const baseUrl = `${window.location.origin}/wechat/authorize/forward?`;
    let redirectAuthorUrl = WxAuthorize.getAuthorizeUrl();
    redirectAuthorUrl = authUtils.padQuery(redirectAuthorUrl, { phone: this.phone });
    const redirect = (domain) => {
      let header = domain ? `${location.protocol}//${domain}` : location.origin;
      let params = {
        officialAccountsId: this.officialAccountsId,
        redirectUrl: `${header}/wechat/authorize/redirectUrl?path=${encodeURIComponent(redirectAuthorUrl)}`,
        snsapiBase: this.snapsis,
        newAuth: true,
        forcePopup: true
      };
      window.location.replace(`${baseUrl}${authUtils.json2params(params)}`);
    };
    try {
      const json = await channelCenterApi.getDomainByWechat({ accountSettingId: this.officialAccountsId });
      const domain = json.domain ? json.domain : json.data.domain;
      redirect(domain);
    } catch(e) {
      redirect();
    }
  }

  static getAuthorizeUrl() {
    const href = window.location.href, search = window.location.search;
    if(search.indexOf('code') > -1) {
      const query = authUtils.params2json(search.slice(1));
      delete query.code;
      return window.location.origin + window.location.pathname + '?' + authUtils.json2params(query);
    } else {
      return href;
    }
  }
}

export default WxAuthorize;
